import AppRoutes from "./routes/AppRoutes";

export default function App() {

    return <AppRoutes />;

}